import React from 'react'
import Typography from '@mui/material/Typography';
import NavTabs from '../DrawerAppBar'

function Footer() {

      const mystyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        marginTop: '32px',
        borderTop: '1px solid #e0e0e0',
    }

    return (
        <div style={mystyle}>
            <Typography style={{textAlign:'center'}}>Copyright IndoHive infotech service pvt ltd@2025</Typography>
        </div>
    )
}

export default Footer